"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.componentsSearch_de_de = void 0;
function componentsSearch_de_de() {
    return {
        "components.search.advancedsearch": "Erweiterte Suche",
        "components.search.contains": "beinhaltet",
        "components.search.matches": "ist gleich",
        "components.search.matcher.exactmatch": "ist gleich",
        "components.search.matcher.equals": "ist gleich",
        "components.search.matcher.includes": "beinhaltet",
        "components.search.matcher.startswith": "beginnt mit",
        "components.search.matcher.endswith": "endet mit",
        "components.search.matcher.exists": "Feld existiert",
        "components.search.matcher.greaterthan": "größer als",
        "components.search.matcher.greaterthanequals": "größer gleich",
        "components.search.matcher.lessthan": "kleiner als",
        "components.search.matcher.lessthanequals": "kleiner gleich",
        "components.search.matcher.beforerelativetime": "vor der relativen Zeit",
        "components.search.matcher.afterrelativetime": "nach der relativen Zeit",
        "components.search.matcher.inrelativemonth": "innerhalb des angegebenen Monats",
        "components.storesearch.mode.simple": "einfach",
        "components.storesearch.mode.advanced": "erweitert",
        "components.storesearch.comperator.or": "oder",
        "components.storesearch.comperator.and": "und",
        "components.storesearch.placeholder": "Nach ${value} suchen"
    };
}
exports.componentsSearch_de_de = componentsSearch_de_de;
